import { notification } from 'antd'

type NotificationType = 'success' | 'info' | 'warning' | 'error'

const mapType: any = {
  "success": "Thành công",
  "warning": "Cảnh báo",
  "error": "Thất bại"
}
const notificationHandler = (type: NotificationType, description: string) => {
  notification[type]({
    message: mapType[type],
    description: description,
  })
}

const capitalize = (s: string) => (s && s[0].toUpperCase() + s.slice(1)) || ""
export default notificationHandler
